import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6",
  height: "6",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0000E7",
  "fill-rule": "evenodd",
  d: "M2.666.251a.75.75 0 0 1 .75.75v3.333a.75.75 0 0 1-1.5 0V1.001a.75.75 0 0 1 .75-.75",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0000E7",
  "fill-rule": "evenodd",
  d: "M.25 2.667a.75.75 0 0 1 .75-.75h3.333a.75.75 0 1 1 0 1.5H1a.75.75 0 0 1-.75-.75",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }